import actions from './actions'

const initialState = {
  rolesList: [],
  rolesActive: [],
  roleSearchText: '',
  rolesListTotal: 0,
  rolesListPagination: {},
  rolesPermissionsList: [],
  rolesPermissionsListTotal: 0,
  rolesActiveRestrictionList: [],
  rolesActiveRestrictionListTotal: 0,
  rolesPermissionsV2List: [],
  rolesPermissionsV2ListTotal: 0,
  rolesPermissionsV2Values: {},
  groupScopePermissionsList: [],
  groupScopePermissionsListTotal: 0,
  groupScopePermissionsValues: {},
  areRolesLoading: false,
}

export default function rolesReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
